<template>
  <div class="mt-2 mx-1">
    <!-- <b-col align="left">
      <b-button-group
        v-b-toggle:collapse-1
        class="my-2 filter-button-group"
        :title="getDefaultFilterMessage()"
      >
        <span class="when-open">
          <b-icon icon="funnel" font-scale="1.5"></b-icon>
        </span>
        <span class="when-closed">
          <b-icon icon="funnel" font-scale="1.5"></b-icon>
        </span>
        Filtra
      </b-button-group>
    </b-col> -->
    <div class="actions-toolbar">
      <div class="d-flex justify-content-between align-items-center">
        <div class="hide-realtime">
          <b-form-checkbox
            name="hide-realtime"
            :checked="hideRealtime"
            @change="onToggleHideRealtime"
            switch
          >
            Nascondo import RealTime
          </b-form-checkbox>
        </div>
        <div class="d-flex" style="gap: 10px">
          <b-button
            type="button"
            variant="secondary"
            size="sm"
            class="btn--smaller btn--transparent"
            @click="onViewImportCal()"
            title="Import calendar"
          >
            <b-icon icon="calendar"></b-icon>
            Calendario Import
          </b-button>
          <b-button
            type="button"
            variant="secondary"
            size="sm"
            class="btn--smaller btn--transparent"
            @click="onRefreshContent()"
            title="Refresh"
          >
            <base-icon name="reload" width="20" height="20" />
            Ricarica
          </b-button>
        </div>
      </div>
    </div>
    <import-calendar-modal></import-calendar-modal>
    <!-- <b-collapse visible id="collapse-1">
      <b-form @submit.prevent="onSearch(filterName)">
        <b-card class="filter">
          <b-row>
            <div class="col-md-3">
              <base-select
                name="insurers"
                label="Compagnia"
                :options="insurers"
                v-model="filter.byInsurer.id"
              />
            </div>
            <div class="col-md-3">
              <base-select
                name="status_import_log"
                label="Stato Importazione"
                :options="status_jobspool"
                v-model="filter.byAttribute.status_jobspool"
              />
            </div>
            <div class="form-group col-md-3 align-self-end">
              <b-button
                type="submit"
                variant="lisaweb"
                size="sm"
                v-b-toggle:collapse-1
                >Cerca</b-button
              >
              <b-button
                class="btn-reset"
                type="button"
                variant="lisaweb"
                size="sm"
                @click="onClearFilter(filterName)"
                >Reset</b-button
              >
            </div>
          </b-row>
        </b-card>
      </b-form>
    </b-collapse> -->
    <annulli-notturni
      :fields="fields"
      :repository="repository"
      :resource="resource"
      :filterOn="filterOn"
      :filterName="filterName"
      :ref="tableRef"
      sortField="last_update"
      descending
    ></annulli-notturni>
  </div>
</template>

<script>
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import AnnulliNotturni from "@/components/tables/AnnulliNotturni.vue";
import BaseIcon from "@/components/BaseIcon";
import ImportCalendarModal from "@/components/modals/viewImportCalendar";
// import BaseSelect from "@/components/form/BaseSelect";
// import { mapActions, mapGetters } from "vuex";
import { toLocaleDate } from "@/utils/dates";

export default {
  mixins: [CustomFiltersMixin],
  data() {
    return {
      repository: "import_log",
      resource: "import_logs",
      filterName: "filterImportLog",
      tableRef: "ImportLogTableRef",
      filter: this.initFilter(),
      hideRealtime: true,
      insurers: [],
      status_import_log: [
        { value: 0, text: "In esecuzione" },
        { value: 1, text: "Terminato con errori" },
        { value: 2, text: "Terminato con successo" },
      ],
      status_jobspool: [
        { value: 0, text: "Upload caricato" },
        { value: 1, text: "Caricamento via API in corso" },
        { value: 2, text: "Caricamento via API terminato" },
        { value: 3, text: "Smistamento al servizio di code" },
        { value: 4, text: "Trasferito al servizio di code" },
        { value: 5, text: "Elaborazione in corso" },
        { value: 6, text: "Elaborazione terminata con successo" },
        { value: 7, text: "Elaborazione terminata con errori" },
      ],
      fields: [
        {
          key: "code",
          label: this.getDictionary("code", "import_log"),
        },
        {
          key: "insurer_id",
          label: this.getDictionary("insurer", "import_log"),
        },
        {
          key: "type_description",
          label: this.getDictionary("type_description", "import_log"),
        },
        {
          key: "status_description",
          label: this.getDictionary("status", "import_log"),
        },
        {
          key: "created_at",
          label: this.getDictionary("created_at", "import_log"),
          formatter: (value) => toLocaleDate(value, "DD/MM/YYYY HH:mm:ss"),
        },
        {
          key: "updated_at",
          label: this.getDictionary("last_update", "import_log"),
          formatter: (value) =>
            value ? toLocaleDate(value, "DD/MM/YYYY HH:mm:ss") : "-",
        },
        // {
        //   key: "details",
        //   label: this.getDictionary("details", "import_log"),
        //   formatter: (value) => (value ? atob(value) : "-"),
        // },
      ],
    };
  },
  components: {
    // BaseSelect,
    AnnulliNotturni,
    BaseIcon,
    ImportCalendarModal,
  },
  computed: {
    filterOn() {
      return {
        byRelations: ["byInsurer", "byImportLog"],
        // il backend esclude le righe di tipo "Realtime" prima di paginare,
        // altrimenti totali e pagine conterebbero righe non mostrate
        ...(this.hideRealtime ? { hide_realtime: 1 } : {}),
      };
    },
  },
  methods: {
    onToggleHideRealtime(checked) {
      this.hideRealtime = checked;
      // il set di risultati cambia: si riparte dalla prima pagina
      this.$refs[this.tableRef].currentPage = 1;
      // la fetch legge filterOn dalla prop della tabella: serve il re-render
      this.$nextTick(() => {
        this.$refs[this.tableRef].fetch();
      });
    },
    onViewImportCal() {
      this.$bvModal.show("viewImportCalendar");
    },
    initFilter() {
      let init = {
        byAttribute: {
          status_jobspool: null,
          job_type: 0,
        },
        byInsurer: {
          id: null,
        },
      };
      return init;
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    onRefreshContent() {
      // let criteria = this.filter;
      // this.saveFilterByName({ name, criteria });
      this.$refs[this.tableRef].fetch();
    },
    onSearch(name) {
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].fetch();
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "last_update";
      this.$refs[this.tableRef].sortDesc = true;
    },
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
    // ...mapActions("filters", {
    //   saveFilterByName: "saveByName",
    //   removeFilterByName: "removeByName",
    // }),
    // ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    // ...mapActions("sorts", {
    //   removeSortByName: "removeByName",
    // }),
  },
  mounted() {
    this.$refs[this.tableRef].fetch();
  },
};
</script>

<style lang="scss" scoped>
.hide-realtime {
  /* la pillola parte dove parte l'icona burger della navbar: `body nav.navbar`
     ha padding-left: calc(1.25rem - 4px) e il root della pagina porta gia' i
     4px di .mx-1, che qui vanno scalati */
  margin-left: calc(1.25rem - 8px);

  /*
   * Interruttore stile iOS: pillola con pomello bianco tondo.
   * Stesse regole di components/profile/permissions/brokers/index.vue.
   * Il colore acceso non si scrive qui: lo impone gia' la regola globale
   * `input[type=checkbox]:checked + label:before { background: var(--lisaweb) !important }`
   * di custom.scss, che segue anche il tema riassegnato a runtime da utils/theme.js.
   */
  :deep(.custom-switch) {
    padding-left: 2.75rem;
    min-height: 1.625rem;

    .custom-control-label {
      /* custom.scss mette padding-top: 5px su .custom-control-label: sposta il
         testo ma non gli pseudo-elementi, quindi qui va azzerato */
      padding-top: 0;
      padding-left: 0.35rem;
      line-height: 1.625rem;
      cursor: pointer;
      /* stesso font dei bottoni della toolbar (.btn: 14px), in grassetto e nero */
      font-size: var(--font-size-md);
      font-weight: 600;
      color: var(--color-text);

      &::before {
        left: -2.75rem;
        top: 0;
        width: 2.75rem;
        height: 1.625rem;
        border-radius: 1rem;
        background-color: var(--gray-100);
        border-color: var(--gray-100);
        transition: background-color 0.2s ease, border-color 0.2s ease;
      }

      &::after {
        left: calc(-2.75rem + 2px);
        top: 2px;
        width: 1.375rem;
        height: 1.375rem;
        border-radius: 50%;
        background-color: #fff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
        transition: transform 0.2s ease;
      }
    }

    .custom-control-input:checked ~ .custom-control-label::after {
      transform: translateX(1.125rem);
      background-color: #fff;
    }
  }
}
</style>
